export default __webpack_public_path__ + "static/media/G_wdt_c_cap_1.efec99e8.mp3";